import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { LANGUAGES, LOCAL_STORAGE_VARS } from 'modules/common/constants/enums';

import commonEn from 'localization/translations/en/common.json';
import commonDe from 'localization/translations/de/common.json';
import planEn from 'localization/translations/en/estatePlan/plan.json';
import planDe from 'localization/translations/de/estatePlan/plan.json';
import fieldLibraryEn from 'localization/translations/en/estatePlan/fieldLibrary.json';
import fieldLibraryDe from 'localization/translations/de/estatePlan/fieldLibrary.json';
import authEn from 'localization/translations/en/auth.json';
import authDe from 'localization/translations/de/auth.json';
import transmortalAuthEn from 'localization/translations/en/transmortalAuth.json';
import transmortalAuthDe from 'localization/translations/de/transmortalAuth.json';
import profileEn from 'localization/translations/en/profile.json';
import profileDe from 'localization/translations/de/profile.json';
import mcontactsEn from 'localization/translations/en/mcontacts.json';
import mcontactsDe from 'localization/translations/de/mcontacts.json';
import contactsEn from 'localization/translations/en/contacts.json';
import contactsDe from 'localization/translations/de/contacts.json';
import faqEn from 'localization/translations/en/faq.json';
import faqDe from 'localization/translations/de/faq.json';
import termsAndConditionsEn from 'localization/translations/en/termsAndConditions.json';
import termsAndConditionsDe from 'localization/translations/de/termsAndConditions.json';
import dashboardEn from 'localization/translations/en/dashboard.json';
import dashboardDe from 'localization/translations/de/dashboard.json';
import assistantEn from 'localization/translations/en/assistant/assistant.json';
import assistantDe from 'localization/translations/de/assistant/assistant.json';
import recommendationsEn from 'localization/translations/en/assistant/recommendations.json';
import recommendationsDe from 'localization/translations/de/assistant/recommendations.json';
import organDonorCardEn from 'localization/translations/en/assistant/organDonorCard.json';
import organDonorCardDe from 'localization/translations/de/assistant/organDonorCard.json';
import patientDecreeEn from 'localization/translations/en/assistant/patientDecree.json';
import patientDecreeDe from 'localization/translations/de/assistant/patientDecree.json';
import healthCareProxyEn from 'localization/translations/en/assistant/healthCareProxy.json';
import healthCareProxyDe from 'localization/translations/de/assistant/healthCareProxy.json';
import willEn from 'localization/translations/en/assistant/will.json';
import willDe from 'localization/translations/de/assistant/will.json';
import initialAssessmentEn from 'localization/translations/en/assistant/initialAssessment.json';
import initialAssessmentDe from 'localization/translations/de/assistant/initialAssessment.json';
import subtypesEn from 'localization/translations/en/subtypes.json';
import subtypesDe from 'localization/translations/de/subtypes.json';
import assetTypeNamingDe from 'localization/translations/de/assetTypeNaming.json';
import assetTypeNamingEn from 'localization/translations/en/assetTypeNaming.json';
import toastrEn from 'localization/translations/en/toastr.json';
import toastrDe from 'localization/translations/de/toastr.json';
import answersEn from 'localization/translations/en/answers.json';
import answersDe from 'localization/translations/de/answers.json';
import tutorialEn from 'localization/translations/en/tutorial.json';
import tutorialDe from 'localization/translations/de/tutorial.json';
import imprintEn from 'localization/translations/en/imprint.json';
import imprintDe from 'localization/translations/de/imprint.json';
import privacyEn from 'localization/translations/en/privacy.json';
import privacyDe from 'localization/translations/de/privacy.json';
import subscriptionEn from 'localization/translations/en/subscription.json';
import subscriptionDe from 'localization/translations/de/subscription.json';
import passPhraseModalEn from 'localization/translations/en/passPhraseModal.json';
import passPhraseModalDe from 'localization/translations/de/passPhraseModal.json';
import paymentDe from 'localization/translations/de/payment.json';
import paymentEn from 'localization/translations/en/payment.json';
import securityKeyEn from 'localization/translations/en/securityKey.json';
import securityKeyDe from 'localization/translations/de/securityKey.json';
import financialSupplyCareDe from 'localization/translations/de/assistant/contentQuestionnaires/financialSupplyCare.json';
import financialSupplyCareEn from 'localization/translations/en/assistant/contentQuestionnaires/financialSupplyCare.json';
import digitalEstateEn from 'localization/translations/en/assistant/contentQuestionnaires/digitalEstate.json';
import digitalEstateDe from 'localization/translations/de/assistant/contentQuestionnaires/digitalEstate.json';
import financialSupplyAgedEn from 'localization/translations/en/assistant/contentQuestionnaires/financialSupplyAged.json';
import financialSupplyAgedDe from 'localization/translations/de/assistant/contentQuestionnaires/financialSupplyAged.json';
import custodyOrderContentEn from 'localization/translations/en/assistant/contentQuestionnaires/custodyOrder.json';
import custodyOrderContentDe from 'localization/translations/de/assistant/contentQuestionnaires/custodyOrder.json';
import bankAuthorizationLetterEn from 'localization/translations/en/assistant/contentQuestionnaires/bankAuthorizationLetter.json';
import bankAuthorizationLetterDe from 'localization/translations/de/assistant/contentQuestionnaires/bankAuthorizationLetter.json';
import inheritanceTaxEn from 'localization/translations/en/assistant/contentQuestionnaires/inheritanceTax.json';
import inheritanceTaxDe from 'localization/translations/de/assistant/contentQuestionnaires/inheritanceTax.json';
import purchaseLoansRightsEn from 'localization/translations/en/assistant/contentQuestionnaires/purchaseLoansRights.json';
import purchaseLoansRightsDe from 'localization/translations/de/assistant/contentQuestionnaires/purchaseLoansRights.json';
import vehicleDocumentsEn from 'localization/translations/en/assistant/contentQuestionnaires/vehicleDocuments.json';
import vehicleDocumentsDe from 'localization/translations/de/assistant/contentQuestionnaires/vehicleDocuments.json';
import landlordRentalAgreementEn from 'localization/translations/en/assistant/contentQuestionnaires/landlordRentalAgreement.json';
import landlordRentalAgreementDe from 'localization/translations/de/assistant/contentQuestionnaires/landlordRentalAgreement.json';
import emergencyPassEn from 'localization/translations/en/assistant/contentQuestionnaires/emergencyPass.json';
import emergencyPassDe from 'localization/translations/de/assistant/contentQuestionnaires/emergencyPass.json';
import postalPowerOfAttorneyEn from 'localization/translations/en/assistant/contentQuestionnaires/postalPowerOfAttorney.json';
import postalPowerOfAttorneyDe from 'localization/translations/de/assistant/contentQuestionnaires/postalPowerOfAttorney.json';
import occupationalDisabilityCareEn from 'localization/translations/en/assistant/contentQuestionnaires/occupationalDisabilityCare.json';
import occupationalDisabilityCareDe from 'localization/translations/de/assistant/contentQuestionnaires/occupationalDisabilityCare.json';
import careDirectiveEn from 'localization/translations/en/assistant/contentQuestionnaires/careDirective.json';
import careDirectiveDe from 'localization/translations/de/assistant/contentQuestionnaires/careDirective.json';

import referralEn from 'localization/translations/en/referral.json';
import referralDe from 'localization/translations/de/referral.json';
import errorsDe from 'localization/translations/de/errors.json';
import errorsEn from 'localization/translations/en/errors.json';
import beneficiaryEn from 'localization/translations/en/beneficiary.json';
import beneficiaryDe from 'localization/translations/de/beneficiary.json';
import zvrRegistrationEn from 'localization/translations/en/zvrRegistration.json';
import zvrRegistrationDe from 'localization/translations/de/zvrRegistration.json';
import shareAssetsEn from 'localization/translations/en/shareAssets.json';
import shareAssetsDe from 'localization/translations/de/shareAssets.json';
import notificationDe from 'localization/translations/de/notification.json';
import notificationEn from 'localization/translations/en/notification.json';
import organDonorCardContentEn from 'localization/translations/en/assistant/contentQuestionnaires/organDonorCard.json';
import organDonorCardContentDe from 'localization/translations/de/assistant/contentQuestionnaires/organDonorCard.json';
import patientDecreeContentEn from 'localization/translations/en/assistant/contentQuestionnaires/patientDecree.json';
import patientDecreeContentDe from 'localization/translations/de/assistant/contentQuestionnaires/patientDecree.json';
import healthCareProxyContentEn from 'localization/translations/en/assistant/contentQuestionnaires/healthCareProxy.json';
import healthCareProxyContentDe from 'localization/translations/de/assistant/contentQuestionnaires/healthCareProxy.json';
import willContentEn from 'localization/translations/en/assistant/contentQuestionnaires/will.json';
import willContentDe from 'localization/translations/de/assistant/contentQuestionnaires/will.json';
import inheritanceTaxCalEn from 'localization/translations/en/estatePlan/inheritanceTaxCal.json';
import inheritanceTaxCalDe from 'localization/translations/de/estatePlan/inheritanceTaxCal.json';
import onBoardingWizardEn from 'localization/translations/en/onBoardingWizard.json';
import onBoardingWizardDe from 'localization/translations/de/onBoardingWizard.json';

import petWatchingAgreementEn from 'localization/translations/en/assistant/petWatchingAgreement.json';
import petWatchingAgreementDE from 'localization/translations/de/assistant/petWatchingAgreement.json';
import custodyOrderEn from 'localization/translations/en/assistant/custodyOrder.json';
import custodyOrderDE from 'localization/translations/de/assistant/custodyOrder.json';
import clientEn from 'localization/translations/en/client.json';
import clientDe from 'localization/translations/de/client.json';

import funeralProvisionDe from 'localization/translations/de/assistant/funeralProvision.json';
import funeralProvisionEn from 'localization/translations/en/assistant/funeralProvision.json';
import funeralProvisionContentDe from 'localization/translations/de/assistant/contentQuestionnaires/funeralProvision.json';
import funeralProvisionContentEn from 'localization/translations/en/assistant/contentQuestionnaires/funeralProvision.json';

import agentsEn from 'localization/translations/en/agents.json';
import agentsDe from 'localization/translations/de/agents.json';

import afterDeathEn from 'localization/translations/en/afterDeath.json';
import afterDeathDe from 'localization/translations/de/afterDeath.json';

import successMessagesEn from 'localization/translations/en/successMessages.json';
import successMessagesDe from 'localization/translations/de/successMessages.json';

// override translation files here
import commonEnExt from 'localization/translations/en/commonExt.json';
import commonDeExt from 'localization/translations/de/commonExt.json';
import planEnExt from 'localization/translations/en/estatePlan/planExt.json';
import planDeExt from 'localization/translations/de/estatePlan/planExt.json';
import authEnExt from 'localization/translations/en/authExt.json';
import authDeExt from 'localization/translations/de/authExt.json';
import transmortalAuthEnExt from 'localization/translations/en/transmortalAuthExt.json';
import transmortalAuthDeExt from 'localization/translations/de/transmortalAuthExt.json';
import profileEnExt from 'localization/translations/en/profileExt.json';
import profileDeExt from 'localization/translations/de/profileExt.json';
import mcontactsEnExt from 'localization/translations/en/mcontactsExt.json';
import mcontactsDeExt from 'localization/translations/de/mcontactsExt.json';
import contactsEnExt from 'localization/translations/en/contactsExt.json';
import contactsDeExt from 'localization/translations/de/contactsExt.json';
import faqEnExt from 'localization/translations/en/faqExt.json';
import faqDeExt from 'localization/translations/de/faqExt.json';
import termsAndConditionsEnExt from 'localization/translations/en/termsAndConditionsExt.json';
import termsAndConditionsDeExt from 'localization/translations/de/termsAndConditionsExt.json';
import dashboardEnExt from 'localization/translations/en/dashboardExt.json';
import dashboardDeExt from 'localization/translations/de/dashboardExt.json';
import assistantEnExt from 'localization/translations/en/assistant/assistantExt.json';
import assistantDeExt from 'localization/translations/de/assistant/assistantExt.json';
import recommendationsEnExt from 'localization/translations/en/assistant/recommendationsExt.json';
import recommendationsDeExt from 'localization/translations/de/assistant/recommendationsExt.json';

import patientDecreeEnExt from 'localization/translations/en/assistant/patientDecreeExt.json';
import patientDecreeDeExt from 'localization/translations/de/assistant/patientDecreeExt.json';

import willEnExt from 'localization/translations/en/assistant/willExt.json';
import willDeExt from 'localization/translations/de/assistant/willExt.json';
import initialAssessmentEnExt from 'localization/translations/en/assistant/initialAssessmentExt.json';
import initialAssessmentDeExt from 'localization/translations/de/assistant/initialAssessmentExt.json';

import answersEnExt from 'localization/translations/en/answersExt.json';
import answersDeExt from 'localization/translations/de/answersExt.json';
import tutorialEnExt from 'localization/translations/en/tutorialExt.json';
import tutorialDeExt from 'localization/translations/de/tutorialExt.json';
import imprintEnExt from 'localization/translations/en/imprintExt.json';
import imprintDeExt from 'localization/translations/de/imprintExt.json';
import privacyEnExt from 'localization/translations/en/privacyExt.json';
import privacyDeExt from 'localization/translations/de/privacyExt.json';

import passPhraseModalEnExt from 'localization/translations/en/passPhraseModalExt.json';
import passPhraseModalDeExt from 'localization/translations/de/passPhraseModalExt.json';
import paymentDeExt from 'localization/translations/de/paymentExt.json';
import paymentEnExt from 'localization/translations/en/paymentExt.json';
import securityKeyEnExt from 'localization/translations/en/securityKeyExt.json';
import securityKeyDeExt from 'localization/translations/de/securityKeyExt.json';

import digitalEstateEnExt from 'localization/translations/en/assistant/contentQuestionnaires/digitalEstateExt.json';
import digitalEstateDeExt from 'localization/translations/de/assistant/contentQuestionnaires/digitalEstateExt.json';

import bankAuthorizationLetterEnExt from 'localization/translations/en/assistant/contentQuestionnaires/bankAuthorizationLetterExt.json';
import bankAuthorizationLetterDeExt from 'localization/translations/de/assistant/contentQuestionnaires/bankAuthorizationLetterExt.json';
import inheritanceTaxEnExt from 'localization/translations/en/assistant/contentQuestionnaires/inheritanceTaxExt.json';
import inheritanceTaxDeExt from 'localization/translations/de/assistant/contentQuestionnaires/inheritanceTaxExt.json';
import purchaseLoansRightsEnExt from 'localization/translations/en/assistant/contentQuestionnaires/purchaseLoansRightsExt.json';
import purchaseLoansRightsDeExt from 'localization/translations/de/assistant/contentQuestionnaires/purchaseLoansRightsExt.json';
import vehicleDocumentsEnExt from 'localization/translations/en/assistant/contentQuestionnaires/vehicleDocumentsExt.json';
import vehicleDocumentsDeExt from 'localization/translations/de/assistant/contentQuestionnaires/vehicleDocumentsExt.json';
import landlordRentalAgreementEnExt from 'localization/translations/en/assistant/contentQuestionnaires/landlordRentalAgreementExt.json';
import landlordRentalAgreementDeExt from 'localization/translations/de/assistant/contentQuestionnaires/landlordRentalAgreementExt.json';

import referralEnExt from 'localization/translations/en/referralExt.json';
import referralDeExt from 'localization/translations/de/referralExt.json';
import errorsDeExt from 'localization/translations/de/errorsExt.json';
import errorsEnExt from 'localization/translations/en/errorsExt.json';
import zvrRegistrationEnExt from 'localization/translations/en/zvrRegistrationExt.json';
import zvrRegistrationDeExt from 'localization/translations/de/zvrRegistrationExt.json';
import shareAssetsEnExt from 'localization/translations/en/shareAssetsExt.json';
import shareAssetsDeExt from 'localization/translations/de/shareAssetsExt.json';
import notificationDeExt from 'localization/translations/de/notificationExt.json';
import notificationEnExt from 'localization/translations/en/notificationExt.json';
import organDonorCardContentEnExt from 'localization/translations/en/assistant/contentQuestionnaires/organDonorCardExt.json';
import organDonorCardContentDeExt from 'localization/translations/de/assistant/contentQuestionnaires/organDonorCardExt.json';
import patientDecreeContentEnExt from 'localization/translations/en/assistant/contentQuestionnaires/patientDecreeExt.json';
import patientDecreeContentDeExt from 'localization/translations/de/assistant/contentQuestionnaires/patientDecreeExt.json';
import willContentEnExt from 'localization/translations/en/assistant/contentQuestionnaires/willExt.json';
import willContentDeExt from 'localization/translations/de/assistant/contentQuestionnaires/willExt.json';

import petWatchingAgreementEnExt from 'localization/translations/en/assistant/petWatchingAgreementExt.json';
import petWatchingAgreementDeExt from 'localization/translations/de/assistant/petWatchingAgreementExt.json';

import funeralProvisionContentDeExt from 'localization/translations/de/assistant/contentQuestionnaires/funeralProvisionExt.json';
import funeralProvisionContentEnExt from 'localization/translations/en/assistant/contentQuestionnaires/funeralProvisionExt.json';

import afterDeathEnExt from 'localization/translations/en/afterDeathExt.json';
import afterDeathDeExt from 'localization/translations/de/afterDeathExt.json';

import toastrEnExt from 'localization/translations/en/toastrExt.json';
import toastrDeExt from 'localization/translations/de/toastrExt.json';

import successMessagesEnExt from 'localization/translations/en/successMessagesExt.json';
import successMessagesDeExt from 'localization/translations/de/successMessagesExt.json';

const lng =
  localStorage.getItem(LOCAL_STORAGE_VARS.SITE_LANGUAGE) || LANGUAGES.DE;
const fallbackLng = lng === LANGUAGES.EN ? LANGUAGES.DE : LANGUAGES.EN;

i18n.use(initReactI18next).init({
  lng,
  fallbackLng,
  debug: false,
  keySeparator: ' ',
  resources: {
    en: {
      common: { ...commonEn, ...commonEnExt },
      plan: { ...planEn, ...planEnExt },
      auth: { ...authEn, ...authEnExt },
      transmortalAuth: { ...transmortalAuthEn, ...transmortalAuthEnExt },
      profile: { ...profileEn, ...profileEnExt },
      mcontacts: { ...mcontactsEn, ...mcontactsEnExt },
      contacts: { ...contactsEn, ...contactsEnExt },
      faq: { ...faqEn, ...faqEnExt },
      termsAndConditions: {
        ...termsAndConditionsEn,
        ...termsAndConditionsEnExt,
      },
      dashboard: { ...dashboardEn, ...dashboardEnExt },
      assistant: { ...assistantEn, ...assistantEnExt },
      recommendations: { ...recommendationsEn, ...recommendationsEnExt },
      patientDecree: { ...patientDecreeEn, ...patientDecreeEnExt },
      organDonorCard: organDonorCardEn,
      healthCareProxy: healthCareProxyEn,
      will: { ...willEn, ...willEnExt },
      initialAssessment: { ...initialAssessmentEn, ...initialAssessmentEnExt },
      subtypes: subtypesEn,
      assetTypeNaming: assetTypeNamingEn,
      toastr: { ...toastrEn, ...toastrEnExt },
      answers: { ...answersEn, ...answersEnExt },
      tutorial: { ...tutorialEn, ...tutorialEnExt },
      imprint: { ...imprintEn, ...imprintEnExt },
      privacy: { ...privacyEn, ...privacyEnExt },
      subscription: subscriptionEn,
      passPhraseModal: { ...passPhraseModalEn, ...passPhraseModalEnExt },
      securityKey: { ...securityKeyEn, ...securityKeyEnExt },
      fieldLibrary: fieldLibraryEn,
      financialSupplyCare: financialSupplyCareEn,
      financialSupplyAged: financialSupplyAgedEn,
      custodyOrderContent: custodyOrderContentDe,
      inheritanceTax: { ...inheritanceTaxEn, ...inheritanceTaxEnExt },
      digitalEstate: { ...digitalEstateEn, ...digitalEstateEnExt },
      purchaseLoansRights: {
        ...purchaseLoansRightsEn,
        ...purchaseLoansRightsEnExt,
      },
      vehicleDocuments: { ...vehicleDocumentsEn, ...vehicleDocumentsEnExt },
      landlordRentalAgreement: {
        ...landlordRentalAgreementEn,
        ...landlordRentalAgreementEnExt,
      },
      bankAuthorizationLetter: {
        ...bankAuthorizationLetterEn,
        ...bankAuthorizationLetterEnExt,
      },
      payment: { ...paymentEn, ...paymentEnExt },
      referral: { ...referralEn, ...referralEnExt },
      errors: { ...errorsEn, ...errorsEnExt },
      beneficiary: beneficiaryEn,
      emergencyPass: emergencyPassEn,
      postalPowerOfAttorney: postalPowerOfAttorneyEn,
      occupationalDisabilityCare: occupationalDisabilityCareEn,
      careDirective: careDirectiveEn,
      zvrRegistration: { ...zvrRegistrationEn, ...zvrRegistrationEnExt },
      shareAssets: { ...shareAssetsEn, ...shareAssetsEnExt },
      notification: { ...notificationEn, ...notificationEnExt },
      patientDecreeContent: {
        ...patientDecreeContentEn,
        ...patientDecreeContentEnExt,
      },
      organDonorCardContent: {
        ...organDonorCardContentEn,
        ...organDonorCardContentEnExt,
      },
      healthCareProxyContent: healthCareProxyContentEn,
      willContent: { ...willContentEn, ...willContentEnExt },
      inheritanceTaxCal: inheritanceTaxCalEn,
      onBoardingWizard: onBoardingWizardEn,
      petWatchingAgreement: {
        ...petWatchingAgreementEn,
        ...petWatchingAgreementEnExt,
      },
      custodyOrder: custodyOrderEn,
      funeralProvision: funeralProvisionEn,
      funeralProvisionContent: {
        ...funeralProvisionContentEn,
        ...funeralProvisionContentEnExt,
      },
      agents: agentsEn,
      afterDeath: { ...afterDeathEn, ...afterDeathEnExt },
      successMessages: { ...successMessagesEn, ...successMessagesEnExt },
      client: clientEn,
    },
    de: {
      common: { ...commonDe, ...commonDeExt },
      plan: { ...planDe, ...planDeExt },
      auth: { ...authDe, ...authDeExt },
      transmortalAuth: { ...transmortalAuthDe, ...transmortalAuthDeExt },
      profile: { ...profileDe, ...profileDeExt },
      mcontacts: { ...mcontactsDe, ...mcontactsDeExt },
      contacts: { ...contactsDe, ...contactsDeExt },
      faq: { ...faqDe, ...faqDeExt },
      termsAndConditions: {
        ...termsAndConditionsDe,
        ...termsAndConditionsDeExt,
      },
      dashboard: { ...dashboardDe, ...dashboardDeExt },
      assistant: { ...assistantDe, ...assistantDeExt },
      recommendations: { ...recommendationsDe, ...recommendationsDeExt },
      patientDecree: { ...patientDecreeDe, ...patientDecreeDeExt },
      organDonorCard: organDonorCardDe,
      healthCareProxy: healthCareProxyDe,
      will: { ...willDe, ...willDeExt },
      initialAssessment: { ...initialAssessmentDe, ...initialAssessmentDeExt },
      subtypes: subtypesDe,
      assetTypeNaming: assetTypeNamingDe,
      toastr: { ...toastrDe, ...toastrDeExt },
      answers: { ...answersDe, ...answersDeExt },
      tutorial: { ...tutorialDe, ...tutorialDeExt },
      imprint: { ...imprintDe, ...imprintDeExt },
      privacy: { ...privacyDe, ...privacyDeExt },
      subscription: subscriptionDe,
      passPhraseModal: { ...passPhraseModalDe, ...passPhraseModalDeExt },
      securityKey: { ...securityKeyDe, ...securityKeyDeExt },
      fieldLibrary: fieldLibraryDe,
      financialSupplyCare: financialSupplyCareDe,
      financialSupplyAged: financialSupplyAgedDe,
      custodyOrderContent: custodyOrderContentEn,
      inheritanceTax: { ...inheritanceTaxDe, ...inheritanceTaxDeExt },
      digitalEstate: { ...digitalEstateDe, ...digitalEstateDeExt },
      purchaseLoansRights: {
        ...purchaseLoansRightsDe,
        ...purchaseLoansRightsDeExt,
      },
      vehicleDocuments: { ...vehicleDocumentsDe, ...vehicleDocumentsDeExt },
      landlordRentalAgreement: {
        ...landlordRentalAgreementDe,
        ...landlordRentalAgreementDeExt,
      },
      bankAuthorizationLetter: {
        ...bankAuthorizationLetterDe,
        ...bankAuthorizationLetterDeExt,
      },
      payment: { ...paymentDe, ...paymentDeExt },
      referral: { ...referralDe, ...referralDeExt },
      errors: { ...errorsDe, ...errorsDeExt },
      beneficiary: beneficiaryDe,
      emergencyPass: emergencyPassDe,
      postalPowerOfAttorney: postalPowerOfAttorneyDe,
      occupationalDisabilityCare: occupationalDisabilityCareDe,
      careDirective: careDirectiveDe,
      zvrRegistration: { ...zvrRegistrationDe, ...zvrRegistrationDeExt },
      shareAssets: { ...shareAssetsDe, ...shareAssetsDeExt },
      notification: { ...notificationDe, ...notificationDeExt },
      patientDecreeContent: {
        ...patientDecreeContentDe,
        ...patientDecreeContentDeExt,
      },
      organDonorCardContent: {
        ...organDonorCardContentDe,
        ...organDonorCardContentDeExt,
      },
      healthCareProxyContent: healthCareProxyContentDe,
      willContent: { ...willContentDe, ...willContentDeExt },
      inheritanceTaxCal: inheritanceTaxCalDe,
      onBoardingWizard: onBoardingWizardDe,
      petWatchingAgreement: {
        ...petWatchingAgreementDE,
        ...petWatchingAgreementDeExt,
      },
      custodyOrder: custodyOrderDE,
      funeralProvision: funeralProvisionDe,
      funeralProvisionContent: {
        ...funeralProvisionContentDe,
        ...funeralProvisionContentDeExt,
      },
      agents: agentsDe,
      afterDeath: { ...afterDeathDe, ...afterDeathDeExt },
      successMessages: { ...successMessagesDe, ...successMessagesDeExt },
      client: clientDe,
    },
  },
  defaultNS: 'common',
});

export default i18n;
